import React, { useRef } from 'react'
/** @jsxImportSource @emotion/react */
import { css} from '@emotion/react'
import { Space,Table ,DatePicker,Pagination, Select, Input} from 'antd';
import { useState } from 'react';
import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import dayjs from 'dayjs';

import axios from '../apiClient';
import Alert from '../alert';
import moment from 'moment/moment';

const {RangePicker} = DatePicker;

export default function OddLogs() {

  const [page,setPage] = useState(1);
  const [searchParams, setSearchParams] = useSearchParams();
  const [oddLogs, setOddLogs] = useState([]);
  const [matchInfo, setMatchInfo] = useState({});
  const [totalLogs,setTotalLogs] = useState();
  const [loading,setLoading] = useState(true)
  const [errorMsg, setErrorMsg] = useState({});
  const [openAlert, setOpenAlert] = useState(false);
  const [periods,setPeriods] = useState("")
  const [betType,setBetType] = useState("")
  const didMount = useRef(false);

  const trnxTypeOptions = ['all', 'betoustanding', 'betting', 'deposit', 'withdraw', 'refund', 'refill']

  const navigate = useNavigate()


  async function fetchData() {
    const matchId =  searchParams.get("matchId");
    setLoading(true)
    // let data = await axios.get(`/api/report/getStatementByMaster?type=${trnxType}&holderName=${searchName}&startDate=${date.startDate} 00:00:00&endDate=${date.endDate} 23:59:59&current=${page}&pageSize=10`)
    let data = await axios.get(`/report/getoddHistoryList?matchId=${matchId}&periods=${periods}&betType=${betType}&current=${page}&pageSize=10`);

    if (data.code != 200) {
        if(data.code == 404){
            setLoading(false)
            setOddLogs([])
            return
        }
        setErrorMsg({ code: data.code, msg: data.message })
        setOpenAlert(true)
        setLoading(false)
        return
    }
    setMatchInfo(data.data?.match)
    setOddLogs(data.data?.odds)
    setTotalLogs(data.data.pagination.total)
    setLoading(false)
  }


  const handleCloseAlert = () => setOpenAlert(false)
  
  const handlePageChange = (page) => setPage(page)

  const handleBetTypeChange = (value) => setBetType(value);

  const handlePeriodsChange = (value) => setPeriods(value);
  

  useEffect(()=> {
      fetchData()
  },[periods,betType,page])

  const columns = [
      {
        title: 'Updated User',
        dataIndex: 'owner_name',
        key: 'owner_name',
      },
      {
        title: 'Updated Date',
        key: 'created_at',
        dataIndex: 'created_at',
        render: (date) => moment(date).format("DD-MM-YYYY h:mm A")
      },
      {
        title: 'Match',
        render: () => matchInfo.homeTeam.name_en + "-" + matchInfo.awayTeam.name_en
      },
      {
        title: 'Hdp',
        dataIndex: 'hdp',
        key: 'hdp',
        render: (hdp) => `${hdp.converted} (${hdp.home_team_has_hadicap ? "Home" : "Away"})`
      },
      {
        title: 'Over/Under',
        key: 'ou',
        dataIndex: 'ou',
        render: (ou) => ou.converted
      },
      {
        title: 'Period',
        key: 'periods',
        dataIndex: 'periods',
      },
      {
        title: 'Bet Type',
        key: 'bet_type',
        dataIndex: 'bet_type',
      }
      
  ];

    return (
      <div>
    <div>
       <Alert openAlert={openAlert} errorMsg={errorMsg} handleCloseAlert={handleCloseAlert}/>
       <div style={{display: 'flex'}}>
          <Select
            defaultValue='all'
            style={{width: "20%"}}
            onChange={handleBetTypeChange}
            // filterOption={(inputValue, option)=> {return option.label.toLowerCase().includes(inputValue.toLowerCase());}}
            showSearch
            options={[
              {label: "All",value: ""},
              {label: "Mix Parlay",value: "mix_parlay"},
              {label: "Single",value: "single"}
            ]}
          />
           <Select
            defaultValue='all'
            style={{width: "20%",marginLeft: "2rem"}}
            onChange={handlePeriodsChange}
            // filterOption={(inputValue, option)=> {return option.label.toLowerCase().includes(inputValue.toLowerCase());}}
            showSearch
            options={[
              {label: "All",value: ""},
              {label: "FT",value: "full_time"},
              {label: "1H",value: "first_time"},
              {label: "2H",value: "second_time"}
            ]}
          />
          
       </div>
      <Table loading={loading} scroll={{ x: 'max-content' }} css={css`padding-top: 2rem;`} pagination={false} columns={columns} dataSource={oddLogs} />
      <Pagination className='pagination' css={css`display: flex;justify-content: end;padding-top: 1rem;`} current={page} total={totalLogs} pageSize={10} showSizeChanger={false} onChange={(page) => handlePageChange(page)} />
    </div>
  </div>
  )
}

